<app-landing-header></app-landing-header>
<app-dynamic-content blocktitle="Marketing - Landing Page - {{lmsUserService.User.GetMemberTypes('ABMP').shift()}}">
</app-dynamic-content>
<app-favorite-course-widget></app-favorite-course-widget>
<app-course-carousel selector="newcourses"></app-course-carousel>
<app-course-carousel selector="trendingcourses"></app-course-carousel>
<app-landing-ce-socials></app-landing-ce-socials>
<app-course-carousel selector="newethics"></app-course-carousel>

<div class="container m-auto d-block text-center">
  <h4>The Best MBLEx Test Prep Just Got Better</h4>
  <a href="https://www.abmp.com/students/abmp-exam-coach-plus">
    <img src="https://learn.cdn.abmp.com/public/ng/ExamCoachPlus.jpg" class="m-auto" id="ecplus" width="900" height="275" />
  </a>
</div>
